/**
 * @import { Feature, LineString } from 'geojson'
 */

import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';

/**
 * @param {Feature<LineString>} feature
 * @param {google.maps.PolylineOptions} options
 */
export function usePolyline(feature, options) {
  const map = useMap();
  const mapsLibrary = useMapsLibrary('maps');
  const [polyline, setPolyline] = useState(/** @type {google.maps.Polyline | null} */ (null));

  // initialize polyline
  useEffect(() => {
    if (mapsLibrary) {
      setPolyline(new mapsLibrary.Polyline(options));
    }
  }, [options, mapsLibrary]);

  // update path
  useEffect(() => {
    polyline?.setPath(feature.geometry.coordinates.map(([lng, lat]) => ({ lat, lng })) ?? []);
  }, [feature, polyline]);

  // add to map
  useEffect(() => {
    if (!map || !polyline) {
      return;
    }

    polyline.setMap(map);

    return () => {
      polyline.setMap(null);
    };
  }, [map, polyline]);

  return { polyline };
}
